export const joinNonEmptyStrings = (
  ...parts: Array<string | undefined | null>
) => parts.filter(Boolean).join('.');
